import { useUserProfile } from '../../../context/UserProfileContext/UserProfileContext';
import {
  useReportingModuleNotifications,
  useFlaModuleNotifications
} from '../../../api/notifications';

export const useNotifications = () => {
  const { userProfile } = useUserProfile();

  const {
    data: reportingModuleNotifications = [],
    isLoading: isReportingModuleNotificationsLoading
  } = useReportingModuleNotifications({
    enabled: userProfile?.allowedModules.canAccessReporting ?? false
  });

  const {
    data: flaModuleNotifications = [],
    isLoading: isFlaModuleNotificationsLoading
  } = useFlaModuleNotifications({
    enabled: userProfile?.allowedModules.canAccessPartnerships ?? false
  });

  return {
    reportingModuleNotifications: reportingModuleNotifications?.sort(
      (notificationA, notificationB) =>
        notificationA.code.localeCompare(notificationB.code)
    ),
    flaModuleNotifications: flaModuleNotifications?.sort(
      (notificationA, notificationB) =>
        notificationA.code.localeCompare(notificationB.code)
    ),
    isLoading:
      isReportingModuleNotificationsLoading || isFlaModuleNotificationsLoading
  };
};
